export default "__VITE_PUBLIC_ASSET__8719f9f1__"